import { Result } from './SelectOptionsRoot';

export const onSubmit = (
  selectedOptions,
  correctAnswers,
  attempt,
  numberOfAttempts,
  setAttempt,
  setResult,
  setShowFeedback,
  showCorrectAnswer,
  setSelectedOptions,
  interactionContext,
  options,
  scoringQuizzes,
  dispatch,
  updateScoreAction,
  addScormResponseAction,
  unlockInteraction,
  setIsLive
) => {
  let result: Result = 'correct';

  for (const key in selectedOptions) {
    if (selectedOptions[key] !== correctAnswers[key]) {
      result = 'incorrect';
    }
  }

  // logic for attempts...
  if (result !== 'correct') {
    if (attempt < numberOfAttempts - 1) {
      setAttempt(attempt => {
        return (attempt += 1);
      });
      result = 'attempt';
    }
  }

  setResult(result);
  setShowFeedback(result);

  if (result === 'incorrect' && showCorrectAnswer) {
    setSelectedOptions(correctAnswers);
  }

  let questionText: any = Array.from(
    document.querySelectorAll(
      `#i${interactionContext.id} form .chameleon-text`
    ) as any
  );

  let [question, ...optionQuestions] = questionText;
  question = question.innerText;

  let responseExpanded: any = Array.from(
    document.querySelectorAll(
      `#i${interactionContext.id} form [class*="placeholder"]`
    ) as any
  );

  if (optionQuestions) {
    //
    optionQuestions = optionQuestions.map((entry, index) => {
      return entry.innerText;
      return `${index + 1}. ${entry.innerText}`;
    });
  }

  let correctExpanded: any = options
    .map((entry, index) => {
      const { id, values, correctAnswer = {} } = entry.props;

      return `${optionQuestions[index]}[.]${
        values[correctAnswer[entry.props.id] || 0]
      }`;
    })
    .join('[,]');

  if (responseExpanded) {
    responseExpanded = responseExpanded
      .map((entry, index) => {
        return `${optionQuestions[index]}[.]${entry.innerText}`;
      })
      .join('[,]');
  }

  const action = {
    id: interactionContext.id,
    type: 'fill-in',
    question: question,
    reportable: 'multichoice' as 'multichoice',
    response: responseExpanded,
    correct: correctExpanded,
    result: result === 'correct' ? 1 : 0,
  };

  // dispatch if there's no scoringQuizzes etc
  let shouldDispatch = true;

  if (scoringQuizzes.length) {
    shouldDispatch = false;
  }
  //

  if (shouldDispatch) {
    dispatch(
      updateScoreAction(interactionContext.id, result === 'correct' ? 1 : 0)
    );
    dispatch(addScormResponseAction(action));
  }

  const unlock = result === 'correct' || attempt === numberOfAttempts - 1;

  if (unlock) {
    unlockInteraction(interactionContext.id);
    setIsLive(false);
  }
};
